import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChartButtonsVisibleService {

  public subscriber: Subject<boolean> = new Subject<boolean>();

}
